import React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import ActionButton from "../../../shared/button/ActionButton";
import { DomesticCountryForm } from "./DomesticCountryForm";
import MUIModal from '../../../shared/MUIModal';

export const AddDomesticCountryDialog = ({
  open,
  onClose,
  onSubmit,
  formState,
  localized,
}) => {
  const {
    countryCode,
    displayName,
    countryCodeTouched,
    displayNameTouched,
    handleCountryCodeChange,
    handleDisplayNameChange,
    handleCountryCodeBlur,
    handleDisplayNameBlur,
    isFormValid,
    dialogError,
    validateCountryCode,
    validateDisplayName,
  } = formState;

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Force validation of all fields by checking if they're valid
    const countryCodeError = validateCountryCode(countryCode);
    const displayNameError = validateDisplayName(displayName);

    if (countryCodeError || displayNameError) {
      if (countryCodeError) {
        handleCountryCodeChange({ target: { value: countryCode } });
      }

      if (displayNameError) {
        handleDisplayNameChange({ target: { value: displayName } });
      }

      return;
    }

    try {
      const success = await onSubmit();
      if (success) {
        onClose();
      }
    } catch (error) {
      console.error("Error submitting domestic country form:", error);
    }
  };

    return (
        <MUIModal
            open={open}
            onClose={onClose}
            title={localized.AddDomesticCountry}
            onSubmit={handleSubmit}
            showDefaultButtons={false}
            maxWidth="sm"
            fullWidth
            customActions={
                <>
                    <ActionButton
                        variant="blue-solid"
                        onClick={onClose}
                        text={localized.Cancel}
                    />
                    <ActionButton
                        variant="blue-solid"
                        type="submit"
                        disabled={!isFormValid}
                        text={localized.Add}
                    />
                </>
            }
        >
            <div style={{ padding: "24px" }}>
                <div style={{ marginBottom: "16px" }}>
                    {localized.FillRequiredFieldsBelow}
                </div>

                <DomesticCountryForm
                    countryCode={countryCode}
                    displayName={displayName}
                    countryCodeTouched={countryCodeTouched}
                    displayNameTouched={displayNameTouched}
                    handleCountryCodeChange={handleCountryCodeChange}
                    handleDisplayNameChange={handleDisplayNameChange}
                    handleCountryCodeBlur={handleCountryCodeBlur}
                    handleDisplayNameBlur={handleDisplayNameBlur}
                    validateCountryCode={validateCountryCode}
                    validateDisplayName={validateDisplayName}
                    localized={localized}
                />

                {dialogError && (
                    <Alert severity="error" sx={{ marginTop: "16px" }}>
                        {dialogError}
                    </Alert>
                )}
            </div>
        </MUIModal>

  );
};

AddDomesticCountryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formState: PropTypes.shape({
    countryCode: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    countryCodeTouched: PropTypes.bool.isRequired,
    displayNameTouched: PropTypes.bool.isRequired,
    handleCountryCodeChange: PropTypes.func.isRequired,
    handleDisplayNameChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    dialogError: PropTypes.string,
    validateCountryCode: PropTypes.func.isRequired,
    validateDisplayName: PropTypes.func.isRequired,
  }).isRequired,
  localized: PropTypes.object.isRequired,
};
